import axios from 'axios'
import router from '@/router';
import api from '@/api';

export const suppliersModule = {
    namespaced: true,

    state:() => ({
        suppliersLoading: false,
        suppliersData: {},
        currentSupplierData: null,
        currentSupplierLoading: true
    }),

    mutations: {
        setSuppliersData(state, data) {
            for(let i = 0; i < data.length; i++) {
                if(data[i].contact) {
                    data[i].contact = data[i].contact.replace(/[^a-zA-Z0-9]/g, "").substring(1)
                    data[i].contact = `7${data[i].contact}`
                }
            }

            state.suppliersData = data
        },

        setCurrentSupplierData(state, data) {
            if(data.contact) {
                data.contact = data.contact.replace(/[^a-zA-Z0-9]/g, "").substring(1)
                data.contact = `7${data.contact}`
            }

            state.currentSupplierData = data
        },

        sortSupplierstData(state, { id, asc }) {
            const array = state.suppliersData
            
            array.sort((a, b) => {
                const valueA = a.find(item => item.id === id).value;
                const valueB = b.find(item => item.id === id).value;

                let comparison = 0;
                if (typeof valueA === 'string' && typeof valueB === 'string') {
                    comparison = valueA.localeCompare(valueB);
                } else {
                    comparison = valueA - valueB;
                }
                
                const data = asc ? comparison : -comparison
                return data;
            });
        }
    },

    actions: {
        getSuppliersData({ state, commit }) {
            state.suppliersLoading = true
            if(router.currentRoute.value.fullPath.split('?')[1]) {
                axios
                .get(api + "projects/tubatay-production/suppliers?" + router.currentRoute.value.fullPath.split('?')[1], {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    console.log(response.data);
                    commit('setSuppliersData', response.data)
                    state.suppliersLoading = false
                })
                .catch((err) => {
                    console.log(err);
                })
            } else {
                axios
                .get(api + "projects/tubatay-production/suppliers/", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    console.log(response.data);
                    commit('setSuppliersData', response.data)
                    state.suppliersLoading = false
                })
                .catch((err) => {
                    console.log(err);
                })
            }

        },

        getCurrentSupplierData({ state, commit }, id) {
            state.currentSupplierLoading = true
            axios
            .get(`${api}projects/tubatay-production/suppliers/${id}?all=true`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setCurrentSupplierData', response.data)
                state.currentSupplierLoading = false
            })
            .catch((err) => {
                console.log(err);
            })
        },

        editSupplierData({ dispatch }, data) {
            axios
            .patch(`${api}projects/tubatay-production/suppliers/${data.id}/?all=true`,
                data,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then(() => {
                dispatch('getSuppliersData')
            })
            .catch((err) => {
                console.log(err);
            })
        },

        getAgreementFile({ state, dispatch, rootState }, data) {
            if (!data?.point?.project_code || !data?.point?.code || !data?.id) {
                console.error("Предоставлены неверные данные");
                return;
            }

            rootState.isLoading = true
        
            axios
                .get(
                    `${api}projects/${data.point.project_code}/shops/${data.point.code}/contracts/?supplier=${data.id}`,
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token'),
                        },
                        responseType: "blob",
                    }
                )
                .then(async (response) => {
                    if (response.status === 200) {
                        await dispatch('getCurrentSupplierData', data.id);
        
                        const url = URL.createObjectURL(response.data);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = `Договор ${state.currentSupplierData?.name || 'Поставщик'} ${data.point.name}.docx`;
                        a.style.display = "none";
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        URL.revokeObjectURL(url);
                    } else {
                        console.error("Не удалось получить файл договора. Status:", response.status);
                    }

                    rootState.isLoading = false
                })
                .catch((err) => {
                    console.error("Ошибка при загрузке файла договора:", err);
                });
        }
    }
}